import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { createEmbedContentRequested } from 'features/content-library/actions';

export function* createLibraryEmbedContentSaga(
  action: ReturnType<typeof createEmbedContentRequested>
) {
  yield call(SignalingSocket.send, { event: 'createLibraryWebapp', data: action.payload });
}
